import { render, staticRenderFns } from "./TableScore.vue?vue&type=template&id=d8cc0618&"
import script from "./TableScore.vue?vue&type=script&lang=js&"
export * from "./TableScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports